import { CompanyForm } from "src/views/pages/CompanyListPage/blocks";

const Company = props => {
  return <CompanyForm {...props} />;
};

export default Company;
